export default {
  style: {
    base: {
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':focus': {
        color: '#424770'
      },
      '::placeholder': {
        color: '#9BACC8'
      },
      ':focus::placeholder': {
        color: '#CFD7DF'
      }
    }
  },
  invalid: {
    iconColor: '#FFC7EE',
    color: '#FFC7EE'
  },
  hidePostalCode: true
}
